const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

export function validateLoginFields({ email, password }) {
  const e = String(email || '').trim();
  const p = String(password || '');

  const errors = {};

  if (!e) errors.email = 'Informe o e-mail.';
  else if (!isValidEmail(e)) errors.email = 'E-mail inválido.';

  if (!p) errors.password = 'Informe a senha.';
  else if (p.length < 6) errors.password = 'Senha muito curta.';

  return {
    ok: Object.keys(errors).length === 0,
    errors,
    email: e,
    password: p,
  };
}
